import script from "./CustomFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomFooter.vue?vue&type=script&setup=true&lang=ts"

import "./CustomFooter.vue?vue&type=style&index=0&id=7442a153&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7442a153"]])

export default __exports__